<template>
  <div class="how_to_about">
    <AboutFrame class="about_frame about1">
      <img class="step" src="/img/how_to_play/15.png" alt="">
      <div class="about_title">
        <h3>Accumulate coin</h3>
        <div>Play the "GACHA" and save up coins to exchange them for prize Earn 0.1 coins for every 100Gems spent.</div>
      </div>
      <div class="content">
        <img src="/img/how_to_play/16.png" alt="">
      </div>
    </AboutFrame>

    <AboutFrame class="about_frame about2">
      <img class="step" src="/img/how_to_play/17.png" alt="">
      <div class="about_title">
        <h3>Monthly Ranking System</h3>
        <div class="num one">Number of gems required to purchase</div>
        <div class="num two">Gem Purchase Discount Rate</div>
        <div class="num three">Number of Coins Required to Maintain Rank</div>
      </div>
      <div class="content">
        <div class="rank_area">
          <img class="rank_img" src="/img/rank/1.png" alt="">
          <div class="rank_txt">
            <img class="rank_bar" src="/img/rank/White.png" alt="">
            <div class="num one">0 gems - 50,000 gems</div>
            <div class="num two">0%</div>
            <div class="num three">0 coins</div>
            <div class="notice">(*Must start at White the following)</div>
          </div>
        </div>
        <div class="rank_area">
          <img class="rank_img" src="/img/rank/2.png" alt="">
          <div class="rank_txt">
            <img class="rank_bar" src="/img/rank/Bronze.png" alt="">
            <div class="num one">50,001 gems to 200,000 gems</div>
            <div class="num two">0%</div>
            <div class="num three">0 coins</div>
            <div class="notice">(*The following month must be White)</div>
          </div>
        </div>
        <div class="rank_area">
          <img class="rank_img" src="/img/rank/3.png" alt="">
          <div class="rank_txt">
            <img class="rank_bar" src="/img/rank/Silver.png" alt="">
            <div class="num one">200,001 gems to 500,000 gems</div>
            <div class="num two">3%</div>
            <div class="num three">500 coins</div>
            <div class="notice">(*If you pay, the following month is Bronze)</div>
          </div>
        </div>
        <div class="rank_area">
          <img class="rank_img" src="/img/rank/4.png" alt="">
          <div class="rank_txt">
            <img class="rank_bar" src="/img/rank/Gold.png" alt="">
            <div class="num one">500,001 gems -to 3 million gems</div>
            <div class="num two">5%</div>
            <div class="num three">3,000 coins</div>
            <div class="notice">(*If you pay, you can start with Sliver the following month)</div>
          </div>
        </div>
        <div class="rank_area">
          <img class="rank_img" src="/img/rank/5.png" alt="">
          <div class="rank_txt">
            <img class="rank_bar" src="/img/rank/Rainbow.png" alt="">
            <div class="num one">3,000,001</div>
            <div class="num two">10%</div>
            <div class="num three">5,000 coins</div>
            <div class="notice">(*If you pay, you can start with Sliver the following month)</div>
          </div>
        </div>
      </div>
    </AboutFrame>

    <AboutFrame class="about_frame about3">
      <img class="step" src="/img/how_to_play/18.png" alt="">
      <div class="about_title">
        <h3>Shipping is free</h3>
        <div>We ship FedEx with free shipping</div>
      </div>
      <div class="content">
        <img src="/img/how_to_play/19.png" alt="">
      </div>
    </AboutFrame>

    <AboutFrame class="about_frame about4">
      <img class="step" src="/img/how_to_play/20.png" alt="">
      <div class="about_title">
        <h3>Post and get Games Campaign</h3>
        <div>If you put the card you receive on “everyone's record” on the site, you will receive 500 Gems!</div>
        <div>※You will not necessarily receive them. Only posts approved by the management will be eligible to receive 500 Gems.</div>
      </div>
      <div class="content">
        <img src="/img/how_to_play/21.png" alt="">
      </div>
    </AboutFrame>

    <AboutFrame class="about_frame about5">
      <img class="step" src="/img/how_to_play/22.png" alt="">
      <div class="about_title">
        <h3>Friend referral Campaign</h3>
        <div>
          Refer a friend and
          <span class="txt_yellow">get 1,000 Gems for both you and your friend!</span>
        </div>
        <div class="notice">(*There is no limit to the number of people you can refer)</div>
        <div class="mt txt">2 conditions for both "Referrer" and "Referred" to get 1,000 Gems</div>
        <div class="mt txt">The person who is referred,</div>
        <div class="txt">1. Complete SMS verification</div>
        <div class="txt">2. Purchase more than 1,000 Gems in total</div>
      </div>
      <div class="content">
        <img src="/img/how_to_play/23.png" alt="">
      </div>
    </AboutFrame>

    <AboutFrame class="about_frame about6">
      <img class="step" src="/img/how_to_play/24.png" alt="">
      <div class="about_title">
        <h3>Linked to the minny online store</h3>
        <div>
          <div class="checkmark"></div>
          Login information is the same as Get24.
        </div>
        <div>
          <div class="checkmark"></div>
          You can use
          <span class="txt_yellow">Get24's Gems </span>
          to buy the cards you like!
        </div>
      </div>
      <div class="content">
        <div class="right_img">
          <img src="/img/how_to_play/26.png" alt="">
        </div>
        <div class="click_here">
          Click here
          <div class="arrow-container">
              <div class="arrow"></div>
          </div>
          <img class="goto_minny" src="/img/how_to_play/25.png" alt="" @click="goToMinny">
        </div>
      </div>
    </AboutFrame>
  </div>
</template>

<script>
import AboutFrame from '@/components/atoms/AboutFrame.vue';

export default {
  name: 'HowtoAboutView',
  components: {
    AboutFrame,
  },
  methods: {
    goToMinny() {
      window.open('https://minny-online-store.iranoan.com', '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.how_to_about {
  background: linear-gradient(to bottom, #146bee, #0094e3);
  position: relative;
  filter: drop-shadow(0 5px 3px rgba(0, 0, 0, 0.7));
  padding: 12px;
  color: $white;
  margin: 10px 10px 0;
  .about_frame {
    position: relative;
    .step {
      position: absolute;
      top: 5px;
      left: 5px;
      width: 9%;
    }
    .about_title {
      margin-left: 11%;
      h3 {
        font-size: 30px;
      }
      div {
        font-size: 18px;
      }
    }
    .content {
      .rank_area {
        position: relative;
        margin-top: 20px;
        .rank_img {
          position: absolute;
          width: 8%;
        }
        .rank_txt {
          margin-left: 11%;
          // .notice {
          //   font-size: 12px;
          // }
          .rank_bar {
            width: 15%;
          }
        }
      }
    }
  }
  .about_frame:not(.about1) {
    margin-top: 20px;
  }
  .about1 {
    .content {
      img {
        width: 100%;
      }
    }
  }
  .about3 {
    display: flex;
    justify-content: space-between;
    .content {
      img {
        width: 50%;
      }
    }
  }
  .about4 {
    .content {
      text-align: end;
      margin-top: -10px;
      img {
        width: 45%;
      }
    }
  }
  .about5 {
    .about_title {
      .mt {
        margin-top: 25px;
      }
    }
    .content {
      img {
        position: absolute;
        width: 12%;
        right: 60px;
        bottom: 10px;
      }
    }
  }
  .about6 {
    .content {
      display: flex;
      .click_here {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
        .arrow-container {
          width: 20px; /* 背景の丸の直径 */
          height: 20px;
          background-color: #4fd1d9; /* 青背景 */
          border-radius: 50%; /* 丸い形状 */
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          margin-left: 5px;
        }
        .arrow {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          position: relative;
          width: 7px; /* 矢印全体の幅 */
          height: 5px; /* 矢印の棒部分の高さ */
          background-color: white; /* 矢印の棒の色 */
          position: absolute;
          left: 4px;
        }
        .arrow::after {
          content: '';
          position: absolute;
          right: -8px; /* 棒の右端に三角形を接続 */
          width: 0;
          height: 0;
          border-top: 5px solid transparent;
          border-bottom: 5px solid transparent;
          border-left: 8px solid white; /* 矢印の三角形部分 */
        }
      }
      img {
        width: 60%;
      }
      .right_img {
        text-align: end;
        img {
          width: 60%;
        }
      }
    }
  }
}
.num {
  font-size: 16px;
}
.one::before {
  content: '1';
  background: $white;
  color: #0094e3;
  border-radius: 50%;
  display: inline-block;
  width: 20px;
  line-height: 20px;
  margin-right: 5px;
  text-align: center;
}
.two::before {
  content: '2';
  background: $white;
  color: #0094e3;
  border-radius: 50%;
  display: inline-block;
  width: 20px;
  line-height: 20px;
  margin-right: 5px;
  text-align: center;
}
.three::before {
  content: '3';
  background: $white;
  color: #0094e3;
  border-radius: 50%;
  display: inline-block;
  width: 20px;
  line-height: 20px;
  margin-right: 5px;
  text-align: center;
}
.txt_yellow {
  color: #ffff4d;
}
.checkmark {
  position: relative;
  display: inline-block;
  width: 20px;
  height: 20px;
  background-color: #4bd37b;
  border-radius: 50%;
}
.checkmark::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 5px;
  border: solid white;
  border-width: 0 0 2px 2px;
  transform: translate(-50%, -60%) rotate(-45deg); /* 中央配置 & 傾き */
}
.goto_minny {
  cursor: pointer;
}
@media screen and (max-width: $tabletWidth) {
  .how_to_about {
    .about_frame {
      .about_title {
        h3 {
          font-size: 24px;
        }
        div {
          font-size: 12px;
        }
      }
      .content {
        .rank_area {
          .rank_txt {
            .notice {
              font-size: 8px;
            }
          }
        }
      }
    }
    .about1 {
      .about_title {
        h3 {
          font-size: 18px;
        }
        div {
          font-size: 9px;
        }
      }
    }
    .about2 {
      .about_title {
        h3 {
          font-size: 18px;
        }
      }
    }
    .about3 {
      .about_title {
        h3 {
          font-size: 18px;
        }
      }
      .content {
        text-align: center;
        img {
          width: 35%;
        }
      }
    }
    .about4 {
      .about_title {
        h3 {
          font-size: 18px;
        }
      }
    }
    .about5 {
      .about_title {
        h3 {
          font-size: 18px;
        }
        .notice {
          font-size: 9px;
        }
        .txt {
          font-size: 10px;
        }
        .mt {
          margin-top: 10px;
        }
      }
      .content {
        img {
          right: 30px;
          bottom: 20px;
        }
      }
    }
    .about6 {
      .about_title {
        h3 {
          font-size: 18px;
        }
      }
      .content {
        .click_here {
          font-size: 10px;
          .arrow-container {
            width: 20px; /* 背景の丸の直径 */
            height: 20px;
          }
          .arrow {
            width: 7px; /* 矢印全体の幅 */
            height: 5px; /* 矢印の棒部分の高さ */
            left: 4px;
          }
          .arrow::after {
            content: '';
            right: -8px; /* 棒の右端に三角形を接続 */
            width: 0;
            height: 0;
            border-top: 5px solid transparent;
            border-bottom: 5px solid transparent;
            border-left: 8px solid white; /* 矢印の三角形部分 */
          }
        }
      }
    }
  }
  .num {
    font-size: 12px;
  }
  .one::before {
    width: 15px;
    line-height: 15px;
  }
  .two::before {
    width: 15px;
    line-height: 15px;
  }
  .three::before {
    width: 15px;
    line-height: 15px;
  }
  .checkmark {
    width: 10px;
    height: 10px;
  }
  .checkmark::before {
    width: 5px;
    height: 3px;
    border-width: 0 0 1px 1px;
  }
}
</style>
